/**
 * Cookie consent state (localStorage-backed).
 * Persisted structure: { necessary: true, analytics, marketing, preferences, timestamp }
 * `necessary` is always true.
 */
const KEY = "tas_cookie_consent";

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveConsent(consent) {
  const value = {
    necessary: true,
    analytics: !!consent.analytics,
    marketing: !!consent.marketing,
    preferences: !!consent.preferences,
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem(KEY, JSON.stringify(value));
  window.dispatchEvent(new Event("tas-consent-change"));
  return value;
}

export function acceptAll() {
  return saveConsent({ analytics: true, marketing: true, preferences: true });
}

export function rejectNonEssential() {
  return saveConsent({ analytics: false, marketing: false, preferences: false });
}
